import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { GlobalProvider } from "GlobalProvider";
import { LoginPage } from "pages/LoginPage";
import { RecipesPage } from "pages/RecipesPage";
import { RecipePage } from "pages/RecipePage";
import { ArticlesPage } from "pages/ArticlesPage";
import { ArticlePage } from "pages/ArticlePage";
import { PagesPage } from "pages/PagesPage";
import { PagePage } from "pages/PagePage";
import { ReviewsPage } from "pages/ReviewsPage";
import { ReviewPage } from "pages/ReviewPage";

export default function App() {
  return (
    <GlobalProvider>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Router>
        <Switch>
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/recipes" component={RecipesPage} />
          <Route exact path="/recipes/:id" component={RecipePage} />
          <Route exact path="/articles" component={ArticlesPage} />
          <Route exact path="/articles/:id" component={ArticlePage} />
          <Route exact path="/reviews" component={ReviewsPage} />
          <Route exact path="/reviews/:id" component={ReviewPage} />
          <Route exact path="/pages" component={PagesPage} />
          <Route exact path="/pages/:id" component={PagePage} />
          <Redirect to="/recipes" />
        </Switch>
      </Router>
    </GlobalProvider>
  );
}
